import useTheme from '@mui/material/styles/useTheme';
import useMediaQuery from '@mui/material/useMediaQuery';
import CardMaster, { CardMasterProps } from './CardMaster';

const DynamicCardSizer: React.FC<CardMasterProps> = (props: any) => {
  const theme = useTheme();
  const isXS = useMediaQuery(theme.breakpoints.up(360));
  const isSM = useMediaQuery(theme.breakpoints.up('sm'));
  const isMD = useMediaQuery(theme.breakpoints.up('md'));
  //   const isLG = useMediaQuery(theme.breakpoints.only('lg'));
  //   const isXL = useMediaQuery(theme.breakpoints.only('xl'));
  //'small' | 'smallplus' | 'medium' | 'large' | 'auto'
  let calculatedSize = 'extrasmall';
  if (isXS) calculatedSize = 'small';
  if (isSM) calculatedSize = 'medium';
  if (isMD) calculatedSize = 'large';
  //   if (isLG) calculatedSize = 'large';
  return <CardMaster {...props} size={calculatedSize} />;
};

export default DynamicCardSizer;
